import axios, { AxiosInstance } from 'axios';
import Vue from 'vue';
import { AuthenticationConfig } from '@/config/authentication';
import VueRouter from 'vue-router';
import moment from 'moment';

export default function BootstrapAxios(
  authConfig: AuthenticationConfig,
  router: VueRouter,
): AxiosInstance {
  const axiosInstance = axios.create({
    baseURL: '/api/v2',
    headers: {
      ClientTimeZone: moment.tz.guess(),
      ClientType: 'STAFF',
    },
  });

  axiosInstance.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response.status === 401) {
        router.push('/login');
      }
      if (
        error.response.status === 503 &&
        router.currentRoute.path !== '/under-maintenance'
      ) {
        router.push('/under-maintenance');
      }
      return Promise.reject(error);
    },
  );

  Vue.prototype.$http = axiosInstance;
  return axiosInstance;
}
